import type { IGetComparisonDesktopResponse } from '../../repositories/offers-comparison/entities/get_comparison_desktop/GetComparisonDesktopResponse';
import type { ICompare } from '../../services/compare';
import type { TCompareType } from '../../types/compareType';
import { prepareOffers } from '../prepareOffers';
import { prepareIds } from '../prepareIds';
import { prepareSeoData } from '../prepareSeoData';
import { prepareProps } from '../prepareProps';
import { transformComparisonOffers } from './transformComparisonOffers';

interface IParameters {
  response: IGetComparisonDesktopResponse;
  compareType: TCompareType;
}

export const prepareComparison = ({ response, compareType }: IParameters): ICompare => {
  const offers = transformComparisonOffers(response);

  return {
    notFoundUrl: response.notFoundUrl,
    offers: prepareOffers(offers),
    ids: prepareIds(offers),
    props: prepareProps(response.props, compareType),
    seoData: prepareSeoData(response.seoData),
  };
};
